import { useEffect, useState } from "react";
import axios from "axios";
import "./VotesSidebar.css";

import v3 from "../../images/save.png";
import v4 from "../../images/moment.png";
import v5 from "../../images/lady.png";

import { END_URL } from "../../config";

// Keep the existing icons in the same order
const perkIcons = [
    "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zm10 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    "M4 5h16v11H9l-5 4V5z",
    "M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm8 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM2 20c0-3 3-5 6-5s6 2 6 5M14 15c3 0 8 1 8 5",
    "M12 3l2.700 5.500 6 .9-4.400 4.200 1 6L12 16.800 6.700 19.600l1-6L3.300 9.400l6-.9L12 3z",
];

const stepTones = ["yellow", "purple", "green"];

const VotesSidebar = () => {
    const [sidebarData, setSidebarData] = useState({
        community_works_title: "How it Works",
        community_how_its_fun: "Why It's Fun",
        how_it_works: [],
        why_its_fun: [],
        images: {},
    });

    useEffect(() => {
        const fetchSidebarData = async () => {
            try {
                const response = await axios.get(
                    `${END_URL}/community-sidebar`
                );

                if (response.data?.success && response.data?.data) {
                    setSidebarData(response.data.data);
                }
            } catch (error) {
                console.error(
                    "Error fetching community sidebar:",
                    error
                );
            }
        };

        fetchSidebarData();
    }, []);

    return (
        <section className="votes-sidebar">
        <div className="votes-sidebar-box" style={{ "--sidebar-image": sidebarData.images?.how_to_play_img ? `url( "${sidebarData.images.how_to_play_img}")` : "none", }}>
            <div className="votes-sidebar-title green">
                <h2>{sidebarData.community_works_title}</h2>
            </div>

            <ul>
                {sidebarData.how_it_works.map((step, index) => (
                <li key={step.id ?? index}>
                    <div className={`votes-sidebar-number ${ stepTones[index % stepTones.length] }`}>
                        {index + 1}
                    </div>

                    <div className="votes-sidebar-text">
                        <h3>{step.how_to_title}</h3>
                        <p>{step.how_to_description}</p>
                    </div>
                </li>
                ))}
            </ul>
        </div>

        <div className="votes-sidebar-note yellow">
            {sidebarData.images?.sticky_img_1 && (
                <img
                    src={sidebarData.images.sticky_img_1}
                    alt=""
                />
            )}
        </div>

        <div className="votes-sidebar-box" style={{ "--sidebar-image": sidebarData.images?.why_its_fun_img ? `url( "${sidebarData.images.why_its_fun_img}")` : "none", }}>
            <div className="votes-sidebar-title pink">
                <h2 className="pink">
                            {sidebarData.community_how_its_fun}
                        </h2>
            </div>

            <ul>
                {sidebarData.why_its_fun.map((perk, index) => (
                <li key={perk.id ?? index}>
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d={perkIcons[index % perkIcons.length]} />
                    </svg>

                    <p>{perk.why_fun_description}</p>
                </li>
                ))}
            </ul>
        </div>

        <div className="votes-sidebar-note yellow">
            {sidebarData.images?.sticky_img_2 && (
                <img
                    src={sidebarData.images.sticky_img_2}
                    alt=""
                />
            )}
        </div>
    </section>
    ); 
}; 

export default VotesSidebar;